import './App.css';
import React from 'react';
import MinimalHome from './components/MinimalHome.js';
import Body from './components/Body.js';
import YtPart from './YtPart.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


const App = () => {


  return (
    <Router>
      <Routes>
        <Route path="/yt" element={<YtPart/>} />
        <Route path="/" element={
        <>
          <MinimalHome/>
          <Body/>
        </>
      } />
      </Routes>
    </Router>
  )
};

export default App;

